module.exports = __webpack_public_path__ + "static/complex_01-5a0dd2c74f597c5a42c61182daa845e3.png";